/**
 * Little Harvesters — Free Shipping Progress Bar
 * Recalculates on any cart mutation and re-renders the bar text,
 * fill width, thumb position, and color state (progress/almost/unlocked).
 *
 * Works with:
 *  - Flux theme's cart drawer AJAX events (listens for 'cart:updated',
 *    'cart:refresh', 'cart:change' — Flux/most modern themes dispatch
 *    one of these after add-to-cart / qty change / remove)
 *  - A safety-net: also patches window.fetch to catch /cart/add.js,
 *    /cart/change.js, /cart/update.js calls in themes that don't
 *    dispatch a custom event.
 */
(function () {
  'use strict';

  function formatMoney(cents, format) {
    // Falls back to Shopify.formatMoney if the theme exposes it,
    // otherwise does a basic USD-style fallback.
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(cents, format);
    }
    var value = (cents / 100).toFixed(2);
    return '$' + value;
  }

  function updateBar(root, cart) {
    var threshold = parseInt(root.dataset.fsbThreshold, 10) || 15000;
    var almostAt = parseInt(root.dataset.fsbAlmost, 10) || 1000;
    var total = cart.total_price;
    var remaining = Math.max(threshold - total, 0);
    var progress = Math.min((total / threshold) * 100, 100);

    var state = 'progress';
    if (remaining === 0) {
      state = 'unlocked';
    } else if (remaining <= almostAt) {
      state = 'almost';
    }
    root.dataset.fsbState = state;

    var fill = root.querySelector('[data-fsb-fill]');
    var thumb = root.querySelector('[data-fsb-thumb]');
    var message = root.querySelector('[data-fsb-message]');

    if (fill) fill.style.width = progress + '%';
    if (thumb) thumb.style.left = progress + '%';

    if (message) {
      if (state === 'unlocked') {
        message.textContent = message.dataset.unlockedText || "You've unlocked free shipping! 🎉";
      } else {
        var template = message.dataset.progressTemplate || "You're %%amount%% away from free shipping";
        message.textContent = template.replace('%%amount%%', formatMoney(remaining));
      }
    }

    var track = root.querySelector('.fsb__track');
    if (track) track.setAttribute('aria-valuenow', String(total));
  }

  function refreshAllBars() {
    var bars = document.querySelectorAll('[data-fsb]');
    if (!bars.length) return;

    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        bars.forEach(function (root) { updateBar(root, cart); });
      })
      .catch(function (err) {
        console.error('[free-shipping-bar] failed to refresh cart', err);
      });
  }

  // Listen for common theme cart-update events (covers Flux + most themes)
  ['cart:updated', 'cart:refresh', 'cart:change', 'cart:build'].forEach(function (evt) {
    document.addEventListener(evt, refreshAllBars);
  });

  // Safety net: hook fetch to catch raw /cart/*.js AJAX calls that don't
  // dispatch a custom event.
  var originalFetch = window.fetch;
  window.fetch = function () {
    var promise = originalFetch.apply(this, arguments);
    var url = arguments[0] instanceof Request ? arguments[0].url : arguments[0];
    if (typeof url === 'string' && /\/cart\/(add|change|update|clear)\.js/.test(url)) {
      promise.then(function () {
        // slight delay lets the theme's own cart state settle first
        setTimeout(refreshAllBars, 50);
      });
    }
    return promise;
  };

  document.addEventListener('DOMContentLoaded', refreshAllBars);
})();